<div class="app-main login-css-new" style="background-image: url('assets/img/login-bg.jpg');">
    <div class="app-content p-0">
        <div class="app-content--inner d-flex align-items-center">
            <div class="flex-grow-1 w-100 d-flex align-items-center">
                <div class="bg-composed-wrapper--content py-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-sm-12 mx-auto text-center align-items-center">

                                <div class="card card-box">
                                    <div class=" justify-content-between px-5 py-5">
                                        <div class="align-items-center pb-4">
                                            <img alt="..." class="w-50 mx-auto d-block img-fluid"
                                                src="assets/img/logo__airport-butler-dark.svg">
                                        </div>
                                        <div class="pl-0">
                                            <div class="text-black mt-3">
                                                <div>
                                                    <form [formGroup]="login_form" (ngSubmit)="onSubmit()">
                                                        <div class="form-group text-left">
                                                            <label>Username *</label>
                                                            <input class="form-control" formControlName="username"
                                                                type="email" required
                                                                [ngClass]="{'is-invalid': submitted && login_form.get('username').errors}"
                                                                placeholder="yourname@yourmail.com">
                                                            <div
                                                                *ngFor="let validation of validation_messages.username">
                                                                <div class="error-message"
                                                                    *ngIf="f.username.hasError(validation.type) &&  ((f.username.dirty || f.username.touched))">
                                                                    {{validation.message }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="form-group mb-4 text-left">
                                                            <div class="d-flex justify-content-between">
                                                                <label>Password *</label>
                                                                <a [routerLink]="['/forgot-password']">Forgot
                                                                    password?</a>
                                                            </div>
                                                            <div class="input-group">
                                                                <input class="form-control"
                                                                    [type]="!hide ? 'password' : 'text'"
                                                                    formControlName="password"
                                                                    [ngClass]="{'is-invalid': submitted && login_form.get('password').errors}"
                                                                    placeholder="Enter your password" required>
                                                                <div class="input-group-append"><span
                                                                        class="input-group-text"
                                                                        style="padding: 0rem 1rem !important;">
                                                                        <mat-icon class="placeholder" *ngIf="hide"
                                                                            tooltip="Hide password" (click)="myFunction()">
                                                                            {{'visibility_off'}}
                                                                        </mat-icon>
                                                                        <mat-icon class="placeholder" *ngIf="!hide"
                                                                            tooltip="Show password" (click)="myFunction()">
                                                                            {{ 'visibility'}}
                                                                        </mat-icon>
                                                                    </span></div>
                                                            </div>
                                                            <div
                                                                *ngFor="let validation of validation_messages.password">
                                                                <div class="error-message"
                                                                    *ngIf="f.password.hasError(validation.type) &&  ((f.password.dirty || f.password.touched))">
                                                                    {{validation.message }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <button style="
                                                    width: 70%;
                                                    display: block;
                                                    margin: 0 auto;
                                                    " class="btn btn-lg btn-second btn-block" type="submit"
                                                            [disabled]="isLogin">Submit</button>
                                                    </form>
                                                    <!-- <div class="text-center pt-3">
                                                        <a [routerLink]="['/forgot-password']">Forgot password?</a>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>